<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container"></hamburger>
    <breadcrumb />
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img src="/img/admin.png" class="user-avatar" v-if="userDetails.wechat_auth_id === 0">
        <img class="user-avatar" :src="userWechatDetails.headimgurl + '?imageView2/1/w/200/h/200/q/75|imageslim'" v-else>
        <i class="el-icon-caret-bottom"/>
      </div>
      <el-dropdown-menu slot="dropdown" class="user-dropdown">
        <el-dropdown-item>
          <span @click="changePswDialogVisible = true">修改密码</span>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <el-popover
            placement="left"
            width="170"
            visible-arrow
            v-model="qrcode"
            trigger="click">
            <div class="qrcode">
              <canvas id="qrccode-canvas" />
              <div style="font-size: 12px; margin-bottom: 5px;">微信扫描二维码绑定</div>
              <div style="font-size: 12px; margin-bottom: 5px;">*请在60秒内完成扫描, 如超时, 请刷新页面后重新绑定*</div>
              <el-button size="mini" @click="refresh()">绑定完成</el-button>
            </div>
            <span @click="wechatBindLink()" slot="reference" v-if="userDetails.wechat_auth_id === 0">微信绑定</span>
          </el-popover>
        </el-dropdown-item>
        <el-dropdown-item v-if="userDetails.wechat_auth_id !== 0">
          <el-popover
            placement="left"
            width="200"
            visible-arrow
            v-model="unbindVisible">
            <p style="font-weight: bold;">确定解除微信绑定？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="unbindVisible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="wechatUnbind()">确定</el-button>
            </div>
            <span style="display:block;" slot="reference">微信解绑</span>
          </el-popover>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <span style="display:block;" @click="logout">LogOut</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dialog :visible.sync="changePswDialogVisible" title="修改密码">
      <el-form ref="passwordForm" :rules="rules" :model="passwordForm" label-width="80px">
        <el-form-item label="旧密码" prop="old_password">
          <el-input v-model="passwordForm.old_password" type="password"/>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="passwordForm.password" type="password"/>
        </el-form-item>
        <el-form-item label="确认密码" prop="password_confirmation">
          <el-input v-model="passwordForm.password_confirmation" type="password"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePswDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="resetPassword()">确 定</el-button>
      </span>
    </el-dialog>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import request from '@/utils/request'
import QRCode from 'qrcode'
var canvas = ''

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.passwordForm.password_confirmation !== '') {
          this.$refs.passwordForm.validateField('password_confirmation')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passwordForm.password) {
        callback(new Error('两次输入的密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      changePswDialogVisible: false,
      passwordForm: {
        old_password: '',
        password: '',
        password_confirmation: ''
      },
      userDetails: [],
      userWechatDetails: [],
      qrcode: false,
      unbindVisible: false,
      rules: {
        old_password: [
          {
            required: true,
            message: '请输入旧密码',
            trigger: 'blur'
          }
        ],
        password: [
          {
            validator: validatePass,
            trigger: 'blur'
          }
        ],
        password_confirmation: [
          {
            validator: validatePass2,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  mounted() {
    this.$nextTick(function() {
      // DOM操作
      canvas = document.getElementById('qrccode-canvas')
    })
  },
  created() {
    this.fetchUser()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    resetPassword() {
      var data = {
        old_password: this.passwordForm.old_password,
        password: this.passwordForm.password,
        password_confirmation: this.passwordForm.password_confirmation
      }
      request({
        url: '/admin/me/password',
        method: 'put',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: '更新登录密码成功',
              type: 'success',
              center: true
            })
            this.passwordForm.old_password = ''
            this.passwordForm.password = ''
            this.passwordForm.password_confirmation = ''
          } else {
            this.$message.error({
              message: '更新登录密码失败',
              center: true
            })
          }
          this.changePswDialogVisible = false
        })
        .catch(error => {
          console.log(error)
          this.$message.error({
            message: '更新登录密码失败',
            center: true
          })
          this.changePswDialogVisible = false
        })
    },
    fetchUser() {
      request({
        url: '/user',
        method: 'get'
      })
        .then(response => {
          this.userDetails = response.data
          if (response.data.wechat_auth && response.data.wechat_auth.user_info) {
            this.userWechatDetails = response.data.wechat_auth.user_info
          }
        })
        .catch(error => {
          console.warn(error)
        })
    },
    refresh() {
      this.qrcode = false
      this.fetchUser()
    },
    createQrcode() {
      this.qrcode = true
      const qrcodeLink = this.wechatLinkData.link
      QRCode.toCanvas(canvas, qrcodeLink, (error) => {
        if (error) {
          console.log(error)
        } else {
          console.log('success')
        }
      })
    },
    wechatBindLink() {
      request({
        url: '/admin/wx/bind/link',
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            this.wechatLinkData = res.data
            this.createQrcode()
          } else if (res.status === -1) {
            this.$message({
              message: 'no appid',
              type: 'warning'
            })
          }
        })
        .catch(error => {
          console.warn(error)
        })
    },
    wechatUnbind() {
      this.unbindVisible = false
      request({
        url: '/admin/wx/unbind',
        method: 'post'
      })
        .then(response => {
          if (response.status === 0) {
            this.$message({
              message: '微信解除绑定成功',
              type: 'success'
            })
          }
          this.fetchUser()
        })
        .catch(error => {
          console.warn(error)
        })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      line-height: initial;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
.qrcode {
    width: 150px;
    height: 200px;
    text-align: center;
    // z-index: 100000;
    // top: 50px;
    // right: 30px;
    // position: fixed;
    // vertical-align: middle;
  }
  .qrcode canvas {
    width: 150px !important;
    height: 150px !important;
  }
</style>
<style type="text/css">
  .el-dialog {
    width: 40%;
  }
  @media only screen and (max-width: 576px) {
    .el-dialog {
      width: 90%;
    }
  }
</style>

